import { Component, ElementRef, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { ChartService } from 'src/app/services/charts/charts.service';
import { MetadataService } from 'src/app/services/metadata/metadata.services';
Chart.register(...registerables);
@Component({
  selector: 'app-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.scss'],
})
export class DoughnutChartComponent implements OnInit, AfterViewInit {
  @Input() title = '';
  @Input() wideMode = false;
  @Input() subscribed = false;
  @Input() description = '';
  @Input() chartHeight: any;
  @Input() classOverlay: any;
  @Input() classOverlayMultiple: any;
  // @Input('chartCategory') chartCategory: any;
  @Input() chartCategory: any;
  @Input() stats: any;
  @Input() legend = true;
  @Input() cutout = 69;
  @Input() offset = 0;

  public doughnutChartData!: any[];
  public doughnutChartLabels!: string[];
  public colors!: string[];
  chart: any;

  public default = true;
  isEmpty = false;

  @ViewChild('chartCanvas') canvasEl!: ElementRef<HTMLCanvasElement>;

  doughnutLabelsLine: any = {
    id: 'doughnutLabelsLine',
    afterDatasetsDraw: (chart: any) => {
      if (
        this.chartCategory !== 'multiple_intelligences' &&
        this.chartCategory !== 'professional_fields' &&
        !this.default
      ) {
        const { ctx } = chart;
        chart.data.datasets.forEach((dataset: any, i: any) => {
          chart.getDatasetMeta(i).data.forEach((datapoint: any, index: any) => {
            const { x, y } = datapoint.tooltipPosition();

            // ctx.fillStyle = dataset.borderColor[index]
            // ctx.fillRect(x, y, 2, 2)

            let label = chart.data.labels[index];

            if (this.chartCategory === 'professional_fields') {
              const firstPhrase = chart.data.labels[index].split('-')[0];
              const secondPhrase = chart.data.labels[index].split('-')[1];
              label = `${firstPhrase[0]}-${secondPhrase[0]}`;
            } else {
              label = chart.data.labels[index];
            }

            const textwidth = ctx.measureText(label).width; //?? get text width in pixels
            ctx.font = '12px Arial';
            ctx.fillStyle = '#374052';

            // control the position
            ctx.fillText(label, x - textwidth / 2, y);
          });
        });
      }
    },
  };

  constructor(
    private chartService: ChartService,
    private meta: MetadataService
  ) { }

  ngOnInit(): void {
    this.doughnutChartData = this.chartService.getChartDataByCategory(
      this.chartCategory
    );
    this.doughnutChartLabels = this.meta.getChartLabels(this.chartCategory);
    this.colors = this.meta.getChartColors(this.chartCategory);
    //setTimeout(() => {
    //  this.initChart();
    //}, 100);
  }

  ngAfterViewInit() {
    this.initChart();
  }

  getChartData() {
    this.doughnutChartData = this.chartService.getChartDataByCategory(
      this.chartCategory
    );
    this.doughnutChartLabels = this.meta.getChartLabels(this.chartCategory);
    this.colors = this.meta.getChartColors(this.chartCategory);
    //setTimeout(() => {
    //  this.initChart();
    //}, 100);
  }

  /*initChart() {
    var canvas: any = document.getElementById(this.chartCategory);
    var ctx2 = canvas.getContext('2d');
    let emptySet = 0;

    this.doughnutChartData.forEach((data: any) => {
      emptySet = data === 0 ? emptySet + 1 : emptySet;
    });
    this.isEmpty = this.doughnutChartData.every((value:number ) => value === 0);

    this.default = emptySet === this.doughnutChartData.length;

    if (this.chartCategory === 'avks' && this.default) {
      this.doughnutChartData = [3, 3, 3];
      this.colors = ['#E6E6E6', '#E6E6E6', '#E6E6E6'];
    }

    this.chart = new Chart(ctx2, {
      type: 'doughnut',
      data: {
        labels: this.doughnutChartLabels,
        datasets: [
          {
            // data: [5, 4, 5, 4, 5, 4, 5],
            data: this.doughnutChartData,
            backgroundColor: this.colors,
            borderColor: this.colors,
            // borderWidth: 10,
            offset: this.offset,
          },
        ],
      },
      options: {
        // layout: {
        //   padding: 20
        // },
        cutout: this.cutout, //?? grosor de la dona
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 1,
        plugins: {
          legend: {
            display: false,
            // position: 'right',
            // labels: {
            //   color: '#777',
            //   font: {
            //     size: this.stats ? 12 : 10,
            //   },
            //   padding: this.stats ? 15 : 10,
            //   pointStyle: 'circle',
            //   usePointStyle: true,
            //   boxHeight: 6,
            //   boxWidth: 6
            // }
          },
          tooltip: {
            enabled: this.default ? false : true,
          },
          datalabels: {
            display: true,
            color: '#FFFFFF',
            font: {
              size: 12,
            },
          },
        },
      },
      plugins: [this.doughnutLabelsLine],
    });
  }*/
  initChart() {
    if (!this.canvasEl) {
      console.warn('Canvas not ready yet');
      return;
    }
    const ctx = this.canvasEl.nativeElement.getContext('2d');
    if (!ctx) {
      console.error('No se pudo obtener el contexto del canvas');
      return;
    }

    this.chart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: this.doughnutChartLabels,
        datasets: [
          {
            data: this.doughnutChartData,
            backgroundColor: this.colors,
            borderColor: this.colors,
            offset: this.offset,
          },
        ],
      },
      options: {
        cutout: this.cutout,
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 1,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: !this.default },
        },
      },
      plugins: [this.doughnutLabelsLine],
    });
  }

  // events
  public chartClicked({ event, active }: { event: any; active: {}[] }): void {
    console.log(event, active);
  }

  public chartHovered({ event, active }: { event: any; active: {}[] }): void {
    console.log(event, active);
  }

  reInitChart() {
    if (this.chart) {
      this.chart.destroy();
    }
    this.getChartData();
    this.initChart();
  }
}
